import { isRef, onScopeDispose, toValue, watch } from 'vue';
/** Subscribes to an event emitter (ref, getter, or raw) and auto-unsubscribes on scope disposal. */
export function onEventEmitter(emitter, callback) {
    if (isRef(emitter) || typeof emitter === 'function') {
        // Emitter is wrapped in ref or getter
        watch(emitter, (newEmitter, oldEmitter) => {
            oldEmitter?.off(callback);
            newEmitter?.on(callback);
        }, { immediate: true });
    }
    else {
        // Raw emitter object
        emitter.on(callback);
    }
    onScopeDispose(() => toValue(emitter)?.off(callback));
}
//# sourceMappingURL=onEventEmitter.js.map